import { useContext, useMemo } from "react";
import WorkspaceContext from "../../WorkSpace/WorkspaceContext";

const isClickInsideActionBox = (event) => {
  return Boolean(event?.target?.closest(".action-box"));
};

export default function useCanvasProductInteractions({
  index,
  isProductClickable = true,
}) {
  const { onCanvasProductSelect, canvasSelectedProductIndex } =
    useContext(WorkspaceContext);

  const isSelected = useMemo(() => {
    return canvasSelectedProductIndex === index;
  }, [canvasSelectedProductIndex, index]);

  const handleProductClick = (event) => {
    if (!isProductClickable || isClickInsideActionBox(event)) return;

    if (isSelected) {
      onCanvasProductSelect(null);
      return;
    }

    onCanvasProductSelect(index);
  };

  const handleEditClick = () => {
    onCanvasProductSelect(index, "edit");
  };

  const handleStyleClick = () => {
    onCanvasProductSelect(index, "style");
  };

  const handleCloseClick = () => {
    onCanvasProductSelect(null);
  };

  return {
    isSelected,
    handleProductClick,
    handleEditClick,
    handleStyleClick,
    handleCloseClick,
  };
}
